import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {
  Box,
  Checkbox,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

const DriversForm = ({ drivers, onAdd, onRemove, selectableDrivers }) => {
  // prettier-ignore
  const handleChange = R.ifElse(
    R.includes(R.__, drivers),
    onRemove,
    onAdd
  );

  return (
    <>
      <Box pb={3}>
        <Box>
          <Typography sx={{ mb: 2, px: 3 }}>
            {R.isEmpty(selectableDrivers) ? 'No Drivers Available' : 'Available Drivers'}
          </Typography>
        </Box>
        {selectableDrivers.map(selectableDriver => {
          const labelId = `checkbox-list-label-${selectableDriver.driverId}`;
          return (
            <Fragment key={selectableDriver.driverId}>
              <ListItem disablePadding key={selectableDriver.driverId}>
                <ListItemButton dense onClick={() => handleChange(selectableDriver)} sx={{ px: 3 }}>
                  <Checkbox
                    checked={R.includes(selectableDriver, drivers)}
                    disableRipple
                    edge="start"
                    tabIndex={-1}
                  />
                  <ListItemText
                    id={labelId}
                    primary={`${selectableDriver.firstName}, ${selectableDriver.lastName}`}
                  />
                </ListItemButton>
              </ListItem>
              <Divider />
            </Fragment>
          );
        })}
      </Box>
    </>
  );
};

DriversForm.propTypes = {
  drivers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  selectableDrivers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default DriversForm;
